import React from 'react'

import { Link } from 'gatsby'
import htmr from 'htmr'
import styled from 'styled-components'

import { colors, space } from '../../style/design-system'

const AutocompleteResults = ({ autocompletedResults, className, getItemProps }) => (
  <div className={`${className} sui-search-box__autocomplete-container`}>
    <ul>
      {autocompletedResults.map((result, i) => {
        let resultToDisplay = result?.title?.snippet || result?.title?.raw || 'Untitled'
        resultToDisplay = resultToDisplay.replace('| Ultimate Medical Academy', '')
          .replace('| UMA', '')

        return (
          <li role="option" key={result.url.raw.replace('https://www.ultimatemedical.edu', '')}>
            <Link
              // onClick={() => dispatch(User.showSearchModal(!displaySearchModal))}
              to={result.url.raw.replace('https://www.ultimatemedical.edu', '')}
              className="autocomplete-result">
              <span className="d-block heading mt-0 mb-2">
                {htmr(resultToDisplay)}
              </span>
            </Link>
          </li>
        )
      })}
    </ul>
  </div>
)

export default styled(AutocompleteResults)`
  background-color: #fff;
  box-shadow: rgba(59, 69, 79, 0.3) 0px 2px 4px;
  border-radius: 4px;
  font-size: 0.9rem;
  position: absolute;
    right: 0; left: 0; top: 115%;
  width: 100%;

  &.sui-search-box__autocomplete-container {
    margin: 0;
    padding: 0;
  }

  &.sui-search-box__autocomplete-container li em {
    background-color: ${colors.dev.blue.i()};
    border-radius: 4px;
    color: ${colors.dev.blue.a()};
    display: inline-block;
    font-style: normal;
    padding: 0 ${space.b};
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  &.sui-search-box__autocomplete-container li {
    padding: 0;
    margin: 0;
    border-radius: 0;

    a {
      border-bottom: 2px solid ${colors.dev.gray.h()};
      display: block;
      padding: 0.75rem;
      text-decoration: none;
    }
    &:hover {
      background-color: ${colors.dev.gray.h()};
      a {
        color: ${colors.dev.gray.b()};
      }
      .body {
        color: ${colors.dev.gray.c()};
      }
      em {
        background: ${colors.dev.gray.i()};
        color: ${colors.dev.gray.b()};
      }
    }
  }

  &.sui-search-box__autocomplete-container li:last-of-type {
    a {
      border-bottom: 0;
    }
  }

  .body {
    color: ${colors.dev.gray.e()};
  }
`
